import React from "react";
import Sidebar from "../components/Sidebar"
import "../css/dashboard.css";
import { Spinner } from "react-bootstrap"
import { useState, useEffect } from "react";

// widget
import WidgetSummary from "../components/WidgetSummary"
import WidgetTable from '../components/WidgetTable';

// ----------------------------------------------------------------------

export default function Dashboard() {

    const [loading, setLoading] = useState(false)

    useEffect(() => {
        setLoading(true);
        setTimeout(() => {
            setLoading(false)
        }, 800);
    }, [])

    return (
        <>
            {
                loading ?

                    <div className="loader-screen">
                        <Spinner className="loader-icon" animation="border" variant="primary" />
                    </div>

                    :

                    <div className="home">
                        <Sidebar />
                        <div className="homeContainer">
                            <div className="widgets">
                                <WidgetSummary type="tutees" />
                                <WidgetSummary type="tutors" />
                                <WidgetSummary type="users" />
                                <WidgetSummary type="verify" />
                            </div>
                            <div className="listContainer">
                                <div className="listTitle">Available Tutors</div>
                                <WidgetTable />
                            </div>
                        </div>
                    </div>
            }
        </>
    )
}